import { __assign } from "tslib";
import { composeHeaders } from './headers';
import { ORIGINAL_HOST_HEADER, ORIGINAL_PROTOCOL_HEADER, ORIGINAL_URL_HEADER, } from './constants';
import { changeHost, extractHost, extractProtocol, isAbsoluteUrl, toSearchQueryParams, } from './utils';
export var buildOptions = function (_a) {
    var requestOptions = _a.requestOptions, urlObject = _a.urlObject, headers = _a.headers, _b = _a.globalConfig, globalConfig = _b === void 0 ? {
        httpMockServer: {
            enabled: false,
        },
    } : _b;
    var url = requestOptions.url, params = requestOptions.params;
    if (params) {
        if (typeof params !== 'object') {
            throw new Error('Search params must be an object');
        }
    }
    var localConfigOptions = maybeRedirectToMockServer(url, globalConfig);
    var newOptions = __assign(__assign(__assign({}, requestOptions), localConfigOptions), { headers: headers });
    return newOptions;
};
export var buildAllHeaders = function (requestOptions, wixHeadersOpts, globalConfig, urlObject) {
    if (globalConfig === void 0) { globalConfig = {
        httpMockServer: {
            enabled: false,
        },
    }; }
    var url = requestOptions.url, disableWixHeaders = requestOptions.disableWixHeaders, headers = requestOptions.headers;
    var composedHeaders = composeHeaders({
        url: url,
        disableWixHeaders: disableWixHeaders,
        wixHeadersOpts: wixHeadersOpts,
    });
    var originalUrlHeader = getUrlHeaders(globalConfig, requestOptions, urlObject);
    return __assign(__assign(__assign({}, composedHeaders), lowerAllJsonKeys(headers)), originalUrlHeader);
};
export var getUrlHeaders = function (globalConfig, requestOptions, urlObject) {
    var _a;
    var url = requestOptions.url, params = requestOptions.params;
    var host = urlObject.host, protocol = urlObject.protocol;
    var originalUrlHeader = globalConfig.httpMockServer.enabled
        ? (_a = {},
            _a[ORIGINAL_URL_HEADER] = buildUrlFromRequest(url, params),
            _a[ORIGINAL_HOST_HEADER] = isAbsoluteUrl(url) ? extractHost(url) : host,
            _a[ORIGINAL_PROTOCOL_HEADER] = isAbsoluteUrl(url)
                ? extractProtocol(url)
                : protocol,
            _a) : {};
    return originalUrlHeader;
};
function maybeRedirectToMockServer(url, globalConfig) {
    if (globalConfig.httpMockServer.enabled) {
        var mockUrl = new URL(globalConfig.httpMockServer.mockServerUrl);
        return {
            url: changeHost(url, mockUrl.host),
        };
    }
    return {};
}
function buildUrlFromRequest(url, requestParams) {
    var _a = new URL(url, 'http://unused.com'), pathname = _a.pathname, searchParams = _a.searchParams;
    requestParams = requestParams || searchParams;
    if (requestParams) {
        var params = toSearchQueryParams(requestParams) || requestParams.toString();
        var paramsAsString = params ? "?".concat(params) : '';
        return "".concat(pathname).concat(paramsAsString);
    }
    return pathname;
}
function lowerAllJsonKeys(objectToChange) {
    objectToChange = objectToChange || {};
    var result = Object.keys(objectToChange).reduce(function (prev, key) {
        var _a;
        return (__assign(__assign({}, prev), (_a = {}, _a[key.toLowerCase()] = objectToChange[key], _a)));
    }, {});
    return result;
}
//# sourceMappingURL=options.js.map